import { ArrayFormFieldBuilder } from '@/forms/builders';
import {
  ArrayFormField,
  FormField,
  StagedFieldsGroupFormField,
} from '@/forms/typings';

export const adaptStagedFieldsGroupFormFieldToArrayFormField = (
  stagedFieldsGroup: StagedFieldsGroupFormField,
): ArrayFormField =>
  new ArrayFormFieldBuilder()
    .fieldId(stagedFieldsGroup.fieldId)
    .name(stagedFieldsGroup.name)
    .title(stagedFieldsGroup.titleWhenFilled ?? '')
    .hint(stagedFieldsGroup.hintWhenFilled ?? '')
    .isRequired(stagedFieldsGroup.isRequired ?? false)
    .isMultiple(false)
    .isEmpty(false)
    .hasAnyValue(stagedFieldsGroup.hasAnyValue)
    .index(stagedFieldsGroup.index)
    .notApplicable(stagedFieldsGroup.notApplicable)
    .allowRemove(stagedFieldsGroup.allowRemove)
    .isCollapsible(true)
    .restriction(stagedFieldsGroup.restriction)
    .fields([
      ...(stagedFieldsGroup.firstStageFields.map(f => ({
        ...f,
        readonly: true,
      })) as Array<Exclude<FormField, ArrayFormField>>),
      ...(stagedFieldsGroup.otherFields as Array<
        Exclude<FormField, ArrayFormField>
      >),
    ])
    .build();
